import { LoanDesistReason } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { LoanDetailAction } from '@/components/widgets/LoanDetailActions/types/LoanDetailAction';

export const LoanStatusChangeSchema = (t, action) =>
  z
    .object({
      additional: z.nativeEnum(LoanDesistReason, t).optional(),
    })
    .strict()
    .refine((data) => !(action === LoanDetailAction.DESIST && !data.additional), {
      message: t('REQUIRED_FIELD'),
      path: ['additional'],
    });

export type LoanStatusChangeType = z.infer<ReturnType<typeof LoanStatusChangeSchema>>;
